module.exports = __webpack_public_path__ + "img/bos.f59cdb37.png";